import { useQuery } from '@tanstack/react-query';
import { Select } from 'antd';
import { getAdditionalTypesDropdown } from 'src/apis/hr_ticket/additionalType.api';
import { SelectProps } from '@martech-solution/utils/types';

export default function AdditionalTypeSelect({
  value,
  onChange,
  style,
  allowClear = true,
  placeholder,
  disabled
}: SelectProps) {
  const additionalTypesDropdownQuery = useQuery({
    queryKey: ['additionalTypesDropdown'],
    queryFn: () => getAdditionalTypesDropdown(),
    staleTime: 60 * 1000
  });

  return (
    <Select
      popupMatchSelectWidth={false}
      allowClear={allowClear}
      value={additionalTypesDropdownQuery.isFetching ? undefined : value}
      style={style}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
      options={additionalTypesDropdownQuery.data?.data.map((data) => ({
        value: data.id,
        label: data.name
      }))}
      showSearch
      filterOption={(input, option) => (option?.label?.toString() ?? '').toLowerCase()?.includes(input.toLowerCase())}
      loading={additionalTypesDropdownQuery.isFetching}
    />
  );
}
